import { GlobalIcon } from "get-life-storybook-ts";
import { useState } from "react";
import {
  CapitalsResponse,
  NewCheckoutI,
  PurchasePeriodT,
} from "../../../../../../api/request/Lead/Interfaces/DataInterface.response";
import { numberFormatPayment } from "../../../../../../utils/Utils";
import {
  CouponInfoI,
  ValidateCouponT,
} from "../../PaymentPage.controller";
import OrderSummaryV3 from "./OrderSummaryV3.component";
import FreqCards from "./FreqCards.component";
import { CAPITAL_TRAITS_FOR_TOTAL, PricesV3T, PromotionV3T } from "../types";

interface MobileSummaryProps {
  checkout: NewCheckoutI;
  capitals?: CapitalsResponse;
  prices?: PricesV3T;
  promotion?: PromotionV3T;
  isAvailableToggle: boolean;
  translate: (key: string) => string;
  validateCoupon?: ValidateCouponT;
  couponInfo?: CouponInfoI;
  handlePurchasePeriod: (value: PurchasePeriodT) => void;
  handleAddCoupon: (code: string, yearlyPrice: number) => void;
  handleRemoveCoupon: (code: string) => void;
  onConditionsClick: () => void;
}

const MobileSummary = (props: MobileSummaryProps) => {
  const [open, setOpen] = useState(false);
  const {
    checkout,
    capitals,
    prices,
    isAvailableToggle,
    translate,
    handlePurchasePeriod,
  } = props;

  // DISABILITY excluded from the total to avoid double-counting with DEATH;
  // see CAPITAL_TRAITS_FOR_TOTAL in ../types.
  const activeTraits = capitals
    ? (Object.keys(capitals) as Array<keyof CapitalsResponse>).filter(
        (key) => capitals[key]?.active
      )
    : [];
  const totalCapital = activeTraits.length
    ? activeTraits
        .filter((k) =>
          (CAPITAL_TRAITS_FOR_TOTAL as readonly string[]).includes(k)
        )
        .reduce((s, k) => s + (capitals![k]?.capital ?? 0), 0)
    : checkout.capital;

  return (
    <div className="paymentV3MobileSummary">
      <div className="paymentV3MobileSummary__header">
        <span className="paymentV3MobileSummary__icon">
          <GlobalIcon iconName="ShieldIcon" size="M" color="#423EF4" />
        </span>
        <span className="paymentV3MobileSummary__capitalLabel">
          {translate("paymentV3.summary.eyebrow")} ·{" "}
          {numberFormatPayment(totalCapital, "capital")} €
        </span>
      </div>

      {isAvailableToggle && (
        <div className="paymentV3MobileSummary__freqCards">
          <FreqCards
            checkout={checkout}
            prices={prices}
            translate={translate}
            handlePurchasePeriod={handlePurchasePeriod}
            variant="compact"
          />
        </div>
      )}

      <button
        type="button"
        className="paymentV3MobileSummary__expand"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        {translate(
          open
            ? "paymentV3.summary.mobile.close"
            : "paymentV3.summary.mobile.open"
        )}
        <span
          className={`paymentV3MobileSummary__expandChevron ${
            open ? "paymentV3MobileSummary__expandChevron--open" : ""
          }`}
        >
          ▾
        </span>
      </button>

      {open && (
        <div className="paymentV3MobileSummary__body">
          <OrderSummaryV3 {...props} hideFreqCards />
        </div>
      )}
    </div>
  );
};

export default MobileSummary;
